import { useEffect, useState } from 'react';

/**
 * Hook to check if the client is mounted
 * @returns boolean indicating if the client is mounted
 */
export const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => setIsClient(true), []);
  return isClient;
};
